import { ObjectForSelection } from '../../types/interfaces/ObjectForSelection';
import { TaskProcessingProcess } from '../../types/interfaces/TaskProcessingProcess';
import { TaskProcessingProcessWithTaskStatuses } from '../../types/interfaces/TaskProcessingProcessWithTaskStatuses';
import IApiCalls from '../api/interfaces/apiCalls';

import BaseService from './BaseService';
import ServiceResult from './interfaces/ServiceResult';
import ITaskProcessingProcessService from './interfaces/TaskProcessingProcessService';

class TaskProcessingProcessService
  extends BaseService<TaskProcessingProcess>
  implements ITaskProcessingProcessService
{
  constructor(apiCalls: IApiCalls) {
    super(apiCalls, 'TaskProcessingProcesses');
  }

  getForSelection(): ServiceResult<ObjectForSelection[] | undefined> {
    const apiCalls = this._apiCalls.beginApiCalls();
    return {
      result: apiCalls.TaskProcessingProcesses.getForSelection(),
      cancel: apiCalls.cancelAllCalls
    };
  }

  getWithTaskStatuses(
    id: number | undefined
  ): ServiceResult<TaskProcessingProcessWithTaskStatuses> {
    const apiCalls = this._apiCalls.beginApiCalls();
    if (!id) {
      return {
        result: apiCalls.TaskStatuses.getForSelection().then((x) => ({
          taskProcessingProcess: undefined,
          taskStatuses: x
        })),
        cancel: apiCalls.cancelAllCalls
      };
    }
    const resultPromise = Promise.all([
      apiCalls.TaskProcessingProcesses.get(id),
      apiCalls.TaskStatuses.getForSelection()
    ]).then(
      ([
        taskProcessingProcess,
        taskStatuses
      ]): TaskProcessingProcessWithTaskStatuses => ({
        taskProcessingProcess,
        taskStatuses
      })
    );
    return { result: resultPromise, cancel: apiCalls.cancelAllCalls };
  }

  // New method to get just the taskProcessingProcess
  getTaskProcessingProcess(
    id: number | undefined
  ): ServiceResult<TaskProcessingProcess | undefined> {
    const apiCalls = this._apiCalls.beginApiCalls();
    if (!id) {
      return {
        result: Promise.resolve(undefined), // Return undefined if no id is provided
        cancel: apiCalls.cancelAllCalls
      };
    }
    const resultPromise = apiCalls.TaskProcessingProcesses.get(id);
    return { result: resultPromise, cancel: apiCalls.cancelAllCalls };
  }
}

export default TaskProcessingProcessService;
